




import {Component, Vue} from "vue-property-decorator";
import axios from "axios";
import {AxiosUtils} from "@/axios-utils";

@Component
export default class Callback extends Vue {
  created() {
    let code = this.$route.query.code;
    let error = this.$route.query.error;
    let errorDesc = this.$route.query.error_description;

    // Auth Codeがあって、ログインに成功した場合
    if (code && !error && !errorDesc) {
      axios.post("/auth/callback", {"code": code})
          .then(cb => {
            // セッションから「リダイレクトURL（メール検証後コールバック）」を取得する
            let redirectUrlForMail = sessionStorage.getItem("redirectUrlForMail");
            // セッションから「指定path」を取得する
            let path = sessionStorage.getItem("path");

            if (redirectUrlForMail) {
              // 「リダイレクトURL（メール検証後コールバック）」が指定されている場合、指定URLへリダイレクト
              sessionStorage.removeItem("redirectUrlForMail"); // 遷移時にはセッションから削除
              window.location.href = redirectUrlForMail;
            } else if (path && path.length > 1) {
              // pathの指定がある場合、指定のURLに遷移
              sessionStorage.removeItem("path"); // 遷移時にはセッションから削除
              this.$router.push(path);
            } else {
              // 上記以外の場合、MyPageに遷移
              this.$router.push("/client/mypage");
            }
          })
          .catch(error => AxiosUtils.gotoClientErrorPage(error, this.$router));

    } else if (error && errorDesc == "メールアドレスの確認(Verify)をしないとログインできません。") {
      // メール未検証エラー
      this.$router.push("/client/mail-confirm-waiting?mailPending=true")
    } else {
      // 予期せぬエラー
      this.$router.push("/client/error")
    }
  }
}
